import React, { useEffect, useState } from "react";
import SignIn from './components/Auth/SignIn';
import VerifyCode from './components/Auth/VerifyCode';
import AdminDashboard from './components/Dashboard/AdminDashboard';
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase/firebaseConfig";

function App() {
  const [step, setStep] = useState('signin'); // 'signin', 'verify', 'addUser', 'dashboard'
  const [email, setEmail] = useState('');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setEmail(currentUser.email);
        setStep('dashboard');
      }
    });
    return () => unsubscribe();
  }, []);

  const handleEmailSubmit = (email) => {
    setEmail(email);
    setStep('verify');
  };

  const handleVerificationSuccess = () => {
    setStep('dashboard');
  };

  if (step === 'signin') {
    return <SignIn onEmailSubmit={handleEmailSubmit} />;
  } else if (step === 'verify') {
    return <VerifyCode email={email} onVerificationSuccess={handleVerificationSuccess} />;
  } else if (step === 'dashboard') {
    return <AdminDashboard />;
  }
}

export default App;
